import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TonalityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tonality"}/>
}
